module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_07.51d5085f.png";